<template>
  <v-content>
    <v-container fluid :style="noPadding === 'true' ? 'padding: 0;' : 'padding: 8px;'">
      <v-layout :style="'max-height: ' + maxHeight + ';'">
        <v-flex style="overflow-y: auto;">
          <slot/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'ContentArea',
  props: ['noPadding', 'deltaHeight'],
  computed: {
    maxHeight: function () {
      return 'calc(100vh - ' + (this.deltaHeight ? this.deltaHeight : '95') + 'px)'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ContentArea.vue